import React, { memo, useEffect, useRef } from 'react';
import { generateID } from '../../base/helper';
import { AIResultsPageProps } from './types';

const Footer: React.FC<AIResultsPageProps> = ({
  id = generateID('clientos-ui-toolkit-ai-results-page-footer'),
  children
}) => {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleStartAnimations = () => {
      if (containerRef.current == null) return;
      const items = Array.from<Element>(
        containerRef.current.getElementsByClassName(
          'clientos-ui-toolkit-recommendation-list__item'
        )
      );
      setTimeout(() => {
        items.forEach((item, index) => {
          item.setAttribute('style', `--delay-time: ${0.2 * (index + 1)}s`);
          item.classList.add('fade-up-animation');
        });
      }, 10);
      const searchInput = containerRef.current?.getElementsByClassName(
        'clientos-ui-toolkit-search-input'
      )[0];
      searchInput.setAttribute('style', '--delay-time: 0.5s');
      searchInput.classList.add('fade-up-animation');
    };
    handleStartAnimations();
  }, [containerRef]);

  return (
    <div
      ref={containerRef}
      className={`clientos-ui-toolkit-ai-results-page__footer`}
      id={id}
    >
      <div
        className="clientos-ui-toolkit-ai-results-page__footer__background"
        id={`${id}__footer__background`}
      />
      {children}
    </div>
  );
};

export default memo(Footer);
